module.exports = __webpack_public_path__ + "fonts/blackberryActive_60x60.39f8b4a17614467c407bd614df60bf8a.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/blackberryActive_60x60.png
// module id = 723
// module chunks = 9